import { render, staticRenderFns } from "./ContactCustomerServicePage.vue?vue&type=template&id=969ae9b2&scoped=true&"
import script from "./ContactCustomerServicePage.vue?vue&type=script&lang=js&"
export * from "./ContactCustomerServicePage.vue?vue&type=script&lang=js&"
import style0 from "./ContactCustomerServicePage.vue?vue&type=style&index=0&id=969ae9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969ae9b2",
  null
  
)

export default component.exports